import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { forwardRef } from 'react';
import { Container } from '../Container.js';
export const IconDownhillSkiing = forwardRef((props, ref) => _jsx(Container, {
  "data-testid": "IconDownhillSkiing",
  ref: ref,
  ...props,
  children: _jsx("path", {
    d: "M740-40q-26 0-50-4t-48-12L108-251q-11-5-16-15t-2-23q5-12 16-17t23-1l247 90 69-178-143-149q-27-28-21-66t39-59l139-80q17-10 35-11t34 5q17 6 30 19t18 31l13 43q13 43 43 76t70 50l12-36q4-12 15-17t22-2 18 15 2 23l-36 109q-74-12-131-58t-84-114l-101 58 105 120q8 8 10 19t-3 22l-80 207 124 45 84-257 28 9 29 7-85 262 31 11q18 6 38 10t40 3q17 0 33-2t32-7q12-4 24 1t16 16q5 12-1 24t-18 15q-20 6-41 10t-45 3m-80-660q-33 0-56-23t-24-57 24-56 56-24 57 24 23 56-23 57-57 23"
  })
}));
IconDownhillSkiing.displayName = 'IconDownhillSkiing';